module.exports = require("@nestjs/throttler");